import {
    VARIANT_TAGS_DISPLAY_BAR,
    VARIANT_TAG_CRUD_FORM_DONE,
    VARIANT_TAG_CRUD_FORM_CANCEL,
    VARIANT_TAG_CRUD_FORM_BATCH_EDIT,
    VARIANT_TAG_CRUD_FORM_DELETE
} from "./actions/VariantEditorActions";
import {
    getTagsByVariantId,
    upsertAllVariantsAndTags,
    deleteAllTagsFromVariants,
    deleteTagsByVariantIds,
    deleteTagsByVariantId,
    upsertTagsByVariantId
} from "../api/actions/VariantActions";
import store from "../redux/Store";
import { $serializeForm } from "../main";

export const enableBatchEditEvent = (e) => {
    return async (dispatch) => {
        dispatch(VARIANT_TAG_CRUD_FORM_BATCH_EDIT());
    };
};
export const enableDeleteEvent = (id) => {
    return async (dispatch, state) => {
        dispatch(VARIANT_TAG_CRUD_FORM_DELETE());
    }
};
export const enableEditEvent = (variant) => {
    return async (dispatch, state) => {

        if (typeof state.variantTags != 'object') {
            state.variantTags = {};
        }

        getTagsByVariantId(variant.id)
            .then((result) => {
                //console.log();
                if (result.content && result.content.id > 0) {
                    state.variantTags[variant.id] = {
                        visibility: true,
                        data: result.content,
                        state: "DONE"
                    };
                    dispatch(VARIANT_TAG_CRUD_FORM_DONE(result.content));
                }

            }).catch((error) => {
                state.variantTags[variant.id] = {
                    visibility: true,
                    data: [],
                    state: "DONE",
                    error: true
                };
                dispatch(VARIANT_TAG_CRUD_FORM_DONE(variant));
            });

        //dispatch(VARIANT_TAG_CRUD_FORM_BATCH_EDIT());
    };
};
export const cancelEditEvent = () => {
    return async (dispatch, state) => {
        dispatch(VARIANT_TAG_CRUD_FORM_CANCEL());
    }
};
export const removeAllTagsByVariantIdEvent = (id) => {
    if (id > 0) {
        deleteTagsByVariantId(id)
            .then((result) => {
                console.log('removeAllTagsByVariantIdEvent', result.content);
            })
            .catch(error => {
                console.error('removeAllTagsByVariantIdEvent', error);
            });
    }

}
export const selectAllVariantsEvent = (list) => {

    let variants = store.getState().base.variants;

    let all = variants.reduce((accumulator, current) => {
        accumulator[current.id] = true;
        return accumulator;
    }, {})

    list.current.setChecked(all);
};
export const selectNoneVariantsEvent = (list) => {
    list.current.setChecked([]);
};
export const updateTagsByVariantIdEvent = (form, id) => {

    const [encoded, decoded] = $serializeForm(form.current);
    let tagsSelected = decoded.tagsSelected;
    let payload = { id: id, tags: tagsSelected };

    upsertTagsByVariantId(payload)
        .then((result) => {
            if (result.content > 0) {
                console.log('upsertTagsByVariantId.result', result);
            }
        })
        .catch((error) => {
            console.log("upsertTagsByVariantId Error:", error, error.error);
        });
};
export const applyTagsToAllSelectedVariantsEvent = (list, input) => {

    let [json, decoded] = $serializeForm(input.current.getForm());
    let tagsSelected = decoded.tagsSelected;
    let variants = Object.keys(list.current.getChecked());
    let payload = { variants: variants, tags: tagsSelected };

    upsertAllVariantsAndTags(payload)
        .then((result) => {
            console.log('applyTagsToAllSelectedVariantsEvent', result.content);
        })
        .catch(error => {
            console.error('applyTagsToAllSelectedVariantsEvent', error);
        });

}
export const removeTagsFromAllSelectedVariantsEvent = (list, input) => {

    let [json, decoded] = $serializeForm(input.current.getForm());
    let tagsSelected = decoded.tagsSelected;
    let variants = Object.keys(list.current.getChecked());
    let payload = { variants: variants, tags: tagsSelected };

    deleteAllTagsFromVariants(payload)
        .then((result) => {
            console.log('removeTagsFromAllSelectedVariantsEvent', result.content);
        })
        .catch(error => {
            console.error('removeTagsFromAllSelectedVariantsEvent', error);
        });
};
export const clearTagsFromSelectedVariantsEvent = (list) => {
    let variants = Object.keys(list.current.getChecked());
    let payload = { ids: variants };

    deleteTagsByVariantIds(payload)
        .then((result) => {
            console.log('clearTagsFromSelectedVariantsEvent', result.content);
        })
        .catch(error => {
            console.error('clearTagsFromSelectedVariantsEvent', error);
        });
}
export const viewTagsByVariantIdEvent = (id) => {
    return async (dispatch, state) => {

        //console.log('viewTagsByVariantIdEvent',);
        let all_tags = store.getState().base.tags;

        if (typeof state.variantTags != 'object') {
            state.variantTags = {};
        }

        var tags = state.variantTags[id];

        if (tags && tags.visibility) {
            tags.visibility = !tags.visibility;
            dispatch(VARIANT_TAGS_DISPLAY_BAR(state.variantTags));
            return;
        }

        state.variantTags[id] = {
            visibility: true,
            data: null,
            state: "LOADING"
        };

        dispatch(VARIANT_TAGS_DISPLAY_BAR(state.variantTags));

        getTagsByVariantId(id)
            .then((result) => {
                //console.log();
                if (result.content && result.content.id > 0) {
                    state.variantTags[id] = {
                        visibility: true,
                        data: result.content,
                        state: "DONE"
                    };
                    dispatch(VARIANT_TAGS_DISPLAY_BAR(state.variantTags));
                }

            }).catch((error) => {
                state.variantTags[id] = {
                    visibility: false,
                    data: error,
                    state: "ERROR",
                    error: true
                };
                dispatch(VARIANT_TAGS_DISPLAY_BAR(state.variantTags));
            });
        //console.log('viewTagGroupDetailsByIdEvent', state);
    }
};